import React from 'react';
import OverflowTooltip from './OverflowTooltip';

interface Props {
  title?: React.ReactNode
  onClick?: () => void
  deferred?: boolean
}

const OverflowContent: React.FC<Props> = ({ title, children, onClick, deferred }) => (
  <div onClick={onClick}>
    <OverflowTooltip
      title={title ?? children}
      placement="top"
      interactive
      arrow
      deferred={deferred}
    >
      {children}
    </OverflowTooltip>
  </div>
);

export default OverflowContent;
